export const ChatStaticData = {
  chatText: 'Chat',
};

export const ChatHindiData = {
  chatText: 'चैट',
};

export const ChatArabicData = {
  chatText: 'الدردشة',
};
